/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';

import {
  Typography,
} from '@material-ui/core';
import BacePolicyEn from '../../components/base_policy_en';

const IndexPage = () => (
  <BacePolicyEn>
    <ul>
      <li><Typography paragraph variant="body2">User Created Data<br />Save your medication record to your device storage.</Typography></li>
      <li><Typography paragraph variant="body2">Image<br />Use to register photos in the medication notes.</Typography></li>
      <li><Typography paragraph variant="body2">Camera<br />Use to take photos of medication notes. The photographed image will be stored in the device's storage.</Typography></li>
      <li><Typography paragraph variant="body2">Contact List<br />Use your email address to create an account ID when you use the backup function to Google Drive.</Typography></li>
      <li><Typography paragraph variant="body2">Sending Information<br />This app provides a backup function to Google Drive or iCloud. When using backup, "user-created data and image data" will be sent to Google Drive or iCloud.</Typography></li>
    </ul>
  </BacePolicyEn>
);

export default IndexPage;
